import {RestService} from './_rest.service'
import {REST_API_END_POINTS} from './constants'
import {SLA} from "../api";

export class SLAService extends RestService<SLA> {
    constructor() {
        super(REST_API_END_POINTS.SLAS)
    }
}
